/* ============================================================================
   hd-vector.js — 矢量引擎（批次1 形状 + 批次2a 填充系统）
   ----------------------------------------------------------------------------
   2026-09-14。外置原因：sections/design-canvas.liquid 逼近 Shopify 256KB 上限
   （铁律：新建 asset 必须先推，再推引用它的 section）。

   依赖（由主 IIFE 显式暴露，**禁止 typeof 探测**）：
     window.__pfmCanvas       — fabric canvas
     window.__pfmAddObject    — 统一添加原语（控制点样式 / 入栈 / 图层刷新）
   自身提供：window.__hdVector = { init, addShape, isShape, syncProps }

   面板分两处：
     #pfmShapePanel — 位于 Shape 侧栏；形状网格 + 形状专属属性（描边/圆角/边数）
     #pfmFillPanel  — 位于固定属性区（不随侧栏切换）；**对任何选中对象生效**（形状/文字）

   设计约束（沿用画板既有范式）：
     · 跨作用域一律通过 deps，不摸主 IIFE 内部变量
     · 选中态规范 = #EDE9FE 底 + #6D28D9 字（边 #C4B5FD）
     · 触控目标：手机 ≥44px / 桌面 36px
     · 禁硬编码画布尺寸 —— 尺寸一律由当前打印区推导
   ============================================================================ */
(function () {
  'use strict';

  /* 外置 asset 必须自带 q —— 否则整个脚本静默不执行（铁律） */
  var q = function (id) { return document.getElementById(id); };
  var ROOT = null;            // #pfmShapePanel
  var FROOT = null;           // #pfmFillPanel
  var bound = false, fbound = false;
  /* 2026-10-28（甲）：色板作用槽 —— 'a'=From / 'b'=To / 'c'=Mid，与 FILL 字段名同名，直接当键用。
     原实现色板点击写死 setFill({a:…}) ⇒ 多色时 To / Mid 根本没法用色板改，Brand 的 + 也永远存 From 色。
     ⚠️ 不写进 FILL / localStorage：纯 UI 态，刷新页面回到 From 最不容易误解。 */
  var CUR_SLOT = 'a';
  var D = null;               // deps

  var LS_SHAPE = 'hdVShape_v1';
  var LS_FILL = 'hdVFill_v1';

  /* 形状专属样式（描边 / 圆角 / 边数） */
  /* 2026-09-16: dash/cap/join = 描边样式，对任何带 stroke 的对象生效（含多选/成组） */
  var DEF_S = { stroke: '#111111', strokeWidth: 0, corner: 0, sides: 6, points: 5,
                dash: 'solid', cap: 'butt', join: 'miter' };
  var STYLE = null;
  /* 通用填充（对形状与文字均生效） */
  var DEF_F = { type: 'solid', a: '#7C3AED', b: '#EC4899', c: '#F59E0B',
                cOn: false, cp: 50, angle: 0, pat: 'dots', patScale: 1 };
  var FILL = null;

  var SWATCHES = ['#7C3AED', '#EC4899', '#0F6E56', '#F59E0B',
                  '#EF4444', '#3B82F6', '#111111', '#FFFFFF'];

  /* 2026-09-16 批次 B（#6 三色停 / #8 图案填充 / #12 色板）
     ----------------------------------------------------------------------
     · 图案 tile 用**同步生成的 canvas** 当 fabric.Pattern.source —— Pattern 接受
       canvas 元素，故 buildFill() 依然保持同步（不必等图片 onload）。
       缩放直接烘进 tile 像素，不用 patternTransform（少一层状态、少一处序列化风险）。
     · 最近颜色 = 自动记录（去重前置、最多 8）；品牌色 = 手动存（最多 6，满了顶掉最旧）。 */
  var PATTERNS = [['dots', 'Dots'], ['stripes', 'Stripes'], ['grid', 'Grid'],
                  ['checks', 'Checks'], ['diag', 'Diagonal']];
  var LS_RECENT = 'hdVRecent_v1', LS_BRAND = 'hdVBrand_v1';
  var RECENT_MAX = 8, BRAND_MAX = 6;

  function patternTile(kind, color, scale) {
    /* 🔴 基点 u 决定「图案看起来是否像图案」：画布 3000² 显示时才 ~0.27 倍，
       一开始取 u=8（一格 16 画布px ≈ 4 屏幕px）⇒ Checks 看起来像细网/噪点，不像图案。
       改成 u=24（一格 48 画布px ≈ 13 屏幕px）在 100% 下才读得出图案；Size 滑杆仍可 50%~300%。 */
    var u = Math.max(12, Math.round(24 * (scale || 1)));   /* 半格 */
    var T = 4;                                             /* 一格内重复次数 */
    var n = u * 2, size = u * 2 * T;
    var cv = document.createElement('canvas');
    cv.width = size; cv.height = size;
    var g = cv.getContext('2d');
    if (!g) return null;
    g.clearRect(0, 0, size, size);
    g.fillStyle = color || '#7C3AED';
    g.strokeStyle = color || '#7C3AED';
    var i, j;
    if (kind === 'stripes') {
      for (i = 0; i < T * 2; i++) g.fillRect(i * u, 0, Math.max(1, u * 0.42), size);
    } else if (kind === 'grid') {
      g.lineWidth = Math.max(1, u * 0.16);   /* 0.3u 时覆盖率 44%，看起来像纱窗不像网格 */
      for (i = 0; i <= T * 2; i++) {
        g.beginPath(); g.moveTo(i * u, 0); g.lineTo(i * u, size); g.stroke();
        g.beginPath(); g.moveTo(0, i * u); g.lineTo(size, i * u); g.stroke();
      }
    } else if (kind === 'checks') {
      for (i = 0; i < T * 2; i++) for (j = 0; j < T * 2; j++) {
        if ((i + j) % 2 === 0) g.fillRect(i * u, j * u, u, u);
      }
    } else if (kind === 'diag') {
      g.lineWidth = Math.max(1, u * 0.34);
      for (i = -T * 2; i < T * 4; i++) {
        g.beginPath(); g.moveTo(i * u, 0); g.lineTo(i * u + size, size); g.stroke();
      }
    } else {
      g.beginPath();
      for (i = 0; i < T; i++) for (j = 0; j < T; j++) {
        var dx = i * n + u, dy = j * n + u, rr = Math.max(1.5, u * 0.40);
        g.moveTo(dx + rr, dy);
        g.arc(dx, dy, rr, 0, Math.PI * 2);
      }
      g.fill();
    }
    return cv;
  }

  function loadList(key) {
    try {
      var r = localStorage.getItem(key), a = r ? JSON.parse(r) : null;
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }
  function saveList(key, a) { try { localStorage.setItem(key, JSON.stringify(a)); } catch (e) { } }
  function pushRecent(hex) {
    if (typeof hex !== 'string' || hex.charAt(0) !== '#') return;
    var h = hex.toLowerCase();
    var a = loadList(LS_RECENT).filter(function (x) { return String(x).toLowerCase() !== h; });
    a.unshift(h);
    saveList(LS_RECENT, a.slice(0, RECENT_MAX));
  }
  /* 小控件图标一律内联 SVG（项目规范，禁字符图标） */
  function svgIco(d) {
    return '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor"'
      + ' stroke-width="2.2" stroke-linecap="round" aria-hidden="true">' + d + '</svg>';
  }

  /* 2026-09-16: 描边样式。fabric 的 strokeDashArray 单位是 px 且**与线宽无关** ——
     固定数组在粗线上会显得过密，故按对象自身线宽等比生成。 */
  var DASHES = [['solid', 'Solid'], ['dash', 'Dashed'], ['dot', 'Dotted'], ['dashdot', 'Dash-dot']];
  var CAPS = [['butt', 'Flat'], ['round', 'Round'], ['square', 'Square']];
  var JOINS = [['miter', 'Sharp'], ['round', 'Round'], ['bevel', 'Bevel']];
  function dashArray(kind, w) {
    var u = Math.max(1, w || 1);
    if (kind === 'dash') return [u * 3, u * 2];
    if (kind === 'dot') return [u * 0.1, u * 1.8];
    if (kind === 'dashdot') return [u * 3, u * 1.6, u * 0.1, u * 1.6];
    return null;   /* solid */
  }
  function opts(list, cur) {
    return list.map(function (x) {
      return '<option value="' + x[0] + '"' + (x[0] === cur ? ' selected' : '') + '>' + x[1] + '</option>';
    }).join('');
  }

  /* ---------- 基础工具 ---------- */
  function CV() { return window.__pfmCanvas || null; }
  function area() { var c = CV(); return (c && c._pfmPrintArea) || null; }

  function readLS(key, def) {
    var o = Object.assign({}, def);
    try { var r = localStorage.getItem(key); if (r) Object.assign(o, JSON.parse(r)); } catch (e) { }
    return o;
  }
  function writeLS(key, o) { try { localStorage.setItem(key, JSON.stringify(o)); } catch (e) { } }

  function loadStyle() { if (!STYLE) STYLE = readLS(LS_SHAPE, DEF_S); return STYLE; }
  function loadFill() { if (!FILL) FILL = readLS(LS_FILL, DEF_F); return FILL; }

  /* 当前色槽（带自动收敛）：非渐变只有 a；三色未开时 Mid 退回 b；Pattern 视为 a。 */
  function curSlot() {
    var f = loadFill();
    var isGrad = (f.type === 'linear' || f.type === 'radial');
    if (!isGrad) return 'a';
    if (CUR_SLOT === 'c' && !f.cOn) return 'b';
    if (CUR_SLOT === 'b' || CUR_SLOT === 'c') return CUR_SLOT;
    return 'a';
  }
  function syncCurSlot() {
    if (!FROOT) return;
    var k = curSlot();
    Array.prototype.forEach.call(FROOT.querySelectorAll('[data-slot]'), function (r) {
      r.classList.toggle('is-cur', r.dataset.slot === k);
    });
  }
  function setCurSlot(k) {
    if (k !== 'a' && k !== 'b' && k !== 'c') return;
    CUR_SLOT = k;
    syncCurSlot();
  }

  /* ---------- 尺寸与落位（一律由打印区推导，禁硬编码） ---------- */
  function baseSize() {
    var pa = area();
    if (pa && pa.width > 0) return Math.round(pa.width * 0.5);
    var c = CV();
    return Math.round((c ? c.width : 800) * 0.5);
  }
  function clampToArea(w, h) {
    var pa = area();
    if (!pa || !(pa.width > 0) || !(pa.height > 0)) return { w: w, h: h };
    var k = Math.min(1, (pa.width * 0.8) / w, (pa.height * 0.8) / h);
    return { w: Math.round(w * k), h: Math.round(h * k) };
  }
  /* 居中到打印区中心。语义与 pfmFitToPrintArea 不同：
     后者是「fit 满打印区」（改 scale），这里是「按给定尺寸居中」（scale 保持 1）。 */
  function centerInArea(o) {
    var c = CV(); if (!c || !o) return;
    var pa = area();
    var cx = (pa && pa.left != null) ? pa.left + pa.width / 2 : c.width / 2;
    var cy = (pa && pa.top != null) ? pa.top + pa.height / 2 : c.height / 2;
    o.set({ left: cx, top: cy, originX: 'center', originY: 'center' });
    if (o.setCoords) o.setCoords();
  }

  /* ================= 填充系统（批次 2a） =================
     用 gradientUnits:'percentage' —— 坐标 0~1，与对象尺寸解耦，
     缩放对象时渐变随比例自适应，无需重算。 */
  var _tileCache = {};
  function tileFor(kind, color, scale) {
    var k = kind + '|' + color + '|' + scale;
    if (!_tileCache[k]) _tileCache[k] = patternTile(kind, color, scale);
    return _tileCache[k];
  }
  /* 色停：默认 2 个；cOn 时把中间色插在 cp% 处（#6） */
  function stopsOf(f) {
    var a = f.a || '#7C3AED', b = f.b || '#EC4899';
    if (!f.cOn) return [{ offset: 0, color: a }, { offset: 1, color: b }];
    var cp = Math.max(5, Math.min(95, f.cp == null ? 50 : f.cp)) / 100;
    return [{ offset: 0, color: a }, { offset: cp, color: f.c || '#F59E0B' },
            { offset: 1, color: b }];
  }
  function buildFill() {
    var f = loadFill();
    if (f.type === 'solid') return f.a || '#7C3AED';
    if (f.type === 'pattern') {
      var tl = tileFor(f.pat || 'dots', f.a || '#7C3AED', f.patScale || 1);
      if (tl && window.fabric && fabric.Pattern) {
        return new fabric.Pattern({ source: tl, repeat: 'repeat' });
      }
      return f.a || '#7C3AED';
    }
    var ang = (f.angle || 0) * Math.PI / 180;
    var co = (f.type === 'linear')
      ? {
          x1: 0.5 - Math.cos(ang) * 0.5, y1: 0.5 - Math.sin(ang) * 0.5,
          x2: 0.5 + Math.cos(ang) * 0.5, y2: 0.5 + Math.sin(ang) * 0.5
        }
      : { x1: 0.5, y1: 0.5, r1: 0, x2: 0.5, y2: 0.5, r2: 0.5 };
    if (!window.fabric || !fabric.Gradient) return f.a || '#7C3AED';
    return new fabric.Gradient({
      type: f.type,
      gradientUnits: 'percentage',
      coords: co,
      colorStops: stopsOf(f)
    });
  }
  /* 判断 fill 是否为本引擎产出的渐变 */
  function isGrad(v) { return !!(v && typeof v === 'object' && v.colorStops); }
  /* 判断 fill 是否为图案。
     🔴 fabric 5.3 的 Pattern 上**既没有实例 `p.type`，也没有 `constructor.type`**（实测：
     `p.type` / `p.constructor.type` 都是 undefined；只有 `toObject()` 里硬编码了
     `type:'pattern'`）。所以真机实测 `v.type === 'pattern'` 永远不成立 —— 会把
     「选中图案对象」误判成纯色、面板模式回填失败。只能靠 instanceof + 特征字段判断。 */
  function isPat(v) {
    if (!v || typeof v !== 'object') return false;
    if (window.fabric && fabric.Pattern && v instanceof fabric.Pattern) return true;
    return v.source !== undefined && v.repeat !== undefined && !v.colorStops;
  }

  /* 可填充目标：**下钻多选 / 成组**，返回要改色的对象数组。
     2026-09-16 修：原先 applyFillToSelection 对 group/activeSelection 直接 return，
     加上 sel() 对多选返回 null ⇒ 填充面板在多选时**整个被隐藏**，「多选改色」根本不可达。 */
  function fillTargets() {
    var c = CV(); if (!c) return [];
    var o = c.getActiveObject(); if (!o) return [];
    var out = [];
    function push(x) {
      if (!x || x.isGrid || x.isPreview) return;
      if (x.type === 'group' || x.type === 'activeSelection') {
        (x.getObjects ? x.getObjects() : []).forEach(push); return;
      }
      if (x.type === 'line') return;          // 线只有描边，无填充
      if (x.type === 'image') return;         // 位图无填充概念（改色走 Colorize）
      out.push(x);
    }
    push(o);
    return out;
  }

  /* 把当前填充应用到选中对象（形状 / 文字 / 路径 / 多选 / 成组均可） */
  function applyFillToSelection() {
    var c = CV(); if (!c) return;
    var tg = fillTargets(); if (!tg.length) return;
    var f0 = loadFill();
    for (var i = 0; i < tg.length; i++) {
      /* 逐个新建填充实例：渐变/图案都是有状态的值对象，跨对象共用一个实例不安全 */
      try { tg[i].set('fill', buildFill()); if (tg[i].setCoords) tg[i].setCoords(); } catch (e) { }
      /* 图案参数留在对象上（canvas.liquid 的 toObject 白名单已含 __pfmPat）——
         重新选中时才能把面板恢复成「图案」模式，否则行与对象对不上。 */
      try {
        if (f0.type === 'pattern') tg[i].__pfmPat = { kind: f0.pat, color: f0.a, scale: f0.patScale };
        else if (tg[i].__pfmPat) delete tg[i].__pfmPat;
      } catch (e2) { }
    }
    c.renderAll();
    if (D && D.save) { try { D.save(); } catch (e) { } }
  }

  /* 描边样式的目标：与填充一致地下钻（形状 / 路径 / 多选 / 成组），图片与网格跳过 */
  function strokeTargets() {
    var c = CV(); if (!c) return [];
    var o = c.getActiveObject(); if (!o) return [];
    var out = [];
    function push(x) {
      if (!x || x.isGrid || x.isPreview || x.type === 'image') return;
      if (x.type === 'group' || x.type === 'activeSelection') {
        (x.getObjects ? x.getObjects() : []).forEach(push); return;
      }
      out.push(x);
    }
    push(o);
    return out;
  }

  /* 2026-09-16: 把 Dash / Ends / Joints 套用到选中对象。
     虚线按**该对象自身的 strokeWidth** 生成（见 dashArray 注释）。 */
  function applyStrokeStyle() {
    var c = CV(); if (!c) return;
    var tg = strokeTargets(); if (!tg.length) return;
    var s = loadStyle();
    for (var i = 0; i < tg.length; i++) {
      var o = tg[i];
      var ow = (typeof o.strokeWidth === 'number' && o.strokeWidth > 0) ? o.strokeWidth : 1;
      try {
        o.set({
          strokeDashArray: dashArray(s.dash || 'solid', ow),
          strokeLineCap: s.cap || 'butt',
          strokeLineJoin: s.join || 'miter'
        });
        if (o.setCoords) o.setCoords();
      } catch (e) { }
    }
    c.renderAll();
    if (D && D.save) { try { D.save(); } catch (e) { } }
  }

  /* ================= 顶点计算 ================= */
  function polyPoints(sides, r) {
    var pts = [], i, a;
    for (i = 0; i < sides; i++) {
      a = -Math.PI / 2 + i * 2 * Math.PI / sides;   // 从正上方起笔
      pts.push({ x: r * Math.cos(a), y: r * Math.sin(a) });
    }
    return pts;
  }
  function starPoints(points, r, innerRatio) {
    var pts = [], i, a, rr;
    for (i = 0; i < points * 2; i++) {
      a = -Math.PI / 2 + i * Math.PI / points;
      rr = (i % 2 === 0) ? r : r * innerRatio;
      pts.push({ x: rr * Math.cos(a), y: rr * Math.sin(a) });
    }
    return pts;
  }

  /* ================= 形状工厂 ================= */
  function baseOpts() {
    var s = loadStyle();
    return {
      fill: buildFill(),
      stroke: s.strokeWidth > 0 ? s.stroke : null,
      strokeWidth: s.strokeWidth > 0 ? s.strokeWidth : 0,
      strokeUniform: true
    };
  }
  function makeShape(kind) {
    var s = loadStyle();
    var b = baseSize();
    var o = null;

    if (kind === 'rect') {
      var r = clampToArea(b, Math.round(b * 0.66));
      o = new fabric.Rect(Object.assign(baseOpts(), {
        width: r.w, height: r.h, rx: s.corner || 0, ry: s.corner || 0
      }));
    } else if (kind === 'ellipse') {
      var e = clampToArea(b, Math.round(b * 0.66));
      o = new fabric.Ellipse(Object.assign(baseOpts(), { rx: e.w / 2, ry: e.h / 2 }));
    } else if (kind === 'triangle') {
      var t = clampToArea(b, Math.round(b * 0.86));
      o = new fabric.Triangle(Object.assign(baseOpts(), { width: t.w, height: t.h }));
    } else if (kind === 'polygon') {
      var pn = clampToArea(b, b);
      o = new fabric.Polygon(polyPoints(Math.max(3, Math.min(12, s.sides || 6)), pn.w / 2), baseOpts());
    } else if (kind === 'star') {
      var st = clampToArea(b, b);
      o = new fabric.Polygon(starPoints(Math.max(3, Math.min(12, s.points || 5)), st.w / 2, 0.42), baseOpts());
    } else if (kind === 'line') {
      var ln = clampToArea(b, b);
      o = new fabric.Line([0, 0, ln.w, 0], {
        stroke: s.stroke || '#111111',
        strokeWidth: Math.max(2, s.strokeWidth || 2),
        strokeLineCap: 'round', fill: null
      });
    } else {
      return null;
    }
    o.pfmName = label(kind);   // 图层显示名（序列化白名单已含 pfmName）
    return o;
  }

  var KIND_LABEL = { rect: 'Rectangle', ellipse: 'Ellipse', triangle: 'Triangle',
                     polygon: 'Polygon', star: 'Star', line: 'Line' };
  function label(kind) { return KIND_LABEL[kind] || 'Shape'; }

  function isShape(o) {
    if (!o || o.type === 'group') return false;
    return /^(rect|ellipse|circle|triangle|polygon|line|path)$/.test(String(o.type));
  }

  /* ================= 添加 ================= */
  function addShape(kind) {
    if (!window.fabric) { toast('Canvas not ready'); return null; }
    if (!window.__pfmAddObject) { toast('Engine not ready'); return null; }
    var o = makeShape(kind);
    if (!o) return null;
    o.pfmShapeKind = kind;
    centerInArea(o);
    var r = window.__pfmAddObject(o, { noSelect: false });
    if (r) { syncProps(); toast(label(kind) + ' added'); }
    return r;
  }

  function toast(msg) {
    try {
      var t = q('pfmVToast');
      if (!t) {
        t = document.createElement('div');
        t.id = 'pfmVToast'; t.className = 'pfm-v-toast';
        document.body.appendChild(t);
      }
      t.textContent = msg; t.style.display = 'block';
      clearTimeout(t._h);
      t._h = setTimeout(function () { t.style.display = 'none'; }, 2200);
    } catch (e) { }
  }

  /* ================= 布尔运算（批次 2b） =================
     paper.js 懒加载 —— 只在首次点布尔按钮时才拉 CDN，不影响首屏。
     链路：fabric 对象 → 提取「画布坐标系」路径 → 变换 → paper 布尔 → 回写 fabric.Path */
  var PAPER_URL = 'https://cdn.jsdelivr.net/npm/paper@0.12.18/dist/paper-core.min.js';
  var _paperReady = false;

  function ensurePaper() {
    if (_paperReady) return Promise.resolve(true);
    if (window.paper) {
      try { paper.setup(new paper.Size(1, 1)); _paperReady = true; return Promise.resolve(true); }
      catch (e) { /* 继续走加载 */ }
    }
    return new Promise(function (res, rej) {
      var sc = document.createElement('script');
      sc.src = PAPER_URL;
      sc.onload = function () {
        try { paper.setup(new paper.Size(1, 1)); _paperReady = true; res(true); }
        catch (e) { rej(e); }
      };
      sc.onerror = function () { rej(new Error('paper.js load failed')); };
      document.head.appendChild(sc);
      setTimeout(function () { if (!_paperReady) rej(new Error('paper.js timeout')); }, 15000);
    });
  }

  /* fabric 对象 → paper 路径（结果为**画布坐标系**）。
     对象局部坐标以自身中心为原点，故先取相对中心的点，再套 calcTransformMatrix。 */
  function objToPaper(obj) {
    var t = obj.type;
    if (t === 'image' || t === 'group' || t === 'activeSelection' ||
        t === 'i-text' || t === 'text' || t === 'textbox') return null;
    var m = obj.calcTransformMatrix();
    var pm = new paper.Matrix(m[0], m[1], m[2], m[3], m[4], m[5]);
    var pp = null;

    if (t === 'rect') {
      var hw = obj.width / 2, hh = obj.height / 2, r = obj.rx || 0;
      pp = (r > 0)
        ? new paper.Path.Rectangle({ point: [-hw, -hh], size: [obj.width, obj.height], radius: r })
        : new paper.Path({ segments: [[-hw, -hh], [hw, -hh], [hw, hh], [-hw, hh]], closed: true });
    } else if (t === 'ellipse' || t === 'circle') {
      pp = new paper.Path.Ellipse({ center: [0, 0], radius: [obj.rx, obj.ry] });
    } else if (t === 'triangle') {
      var tw = obj.width / 2, th = obj.height / 2;
      pp = new paper.Path({ segments: [[0, -th], [tw, th], [-tw, th]], closed: true });
    } else if (t === 'polygon') {
      var off = obj.pathOffset || { x: 0, y: 0 };
      pp = new paper.Path({ segments: obj.points.map(function (q) { return [q.x - off.x, q.y - off.y]; }), closed: true });
    } else if (t === 'line') {
      var lw = obj.width, off2 = obj.pathOffset || { x: 0, y: 0 };
      pp = new paper.Path({ segments: [[-off2.x, -off2.y], [lw - off2.x, -off2.y]], closed: false });
    } else if (t === 'path') {
      var d = obj.path.map(function (seg) { return seg[0] + seg.slice(1).join(' '); }).join(' ');
      try {
        pp = new paper.Path({ pathData: d });
        var o3 = obj.pathOffset || { x: 0, y: 0 };
        pp.translate(-o3.x, -o3.y);
      } catch (e) { return null; }
    }
    if (!pp) return null;
    pp.transform(pm);
    return pp;
  }

  /* paper 结果 → fabric.Path。
     ⚠️ 关键：不依赖 fabric.Path 的 pathOffset 内部语义 —— 先建对象，
     再比对「实际包围盒 vs 目标包围盒」反推补偿 left/top（含旋转对象同样准确）。 */
  function toFabricPath(pp, attrs) {
    var d = String(pp.pathData);
    var tgt = pp.bounds;
    var o = new fabric.Path(d, Object.assign({
      originX: 'left', originY: 'top', left: 0, top: 0
    }, attrs || {}));
    o.setCoords();
    var bb = o.getBoundingRect(true, true);
    o.set({ left: (o.left || 0) + (tgt.x - bb.left), top: (o.top || 0) + (tgt.y - bb.top) });
    o.setCoords();
    return o;
  }

  /* 2026-09-14 批次4d（沿任意路径文字）：形状 → **画布坐标** path d 字符串。
     直接复用 objToPaper —— 它已把对象的变换矩阵（scale/angle）**焙焙进路径点**，
     而 fabric 的 text.path **不会应用 path 自身的 transform**（PoC 实测）—— 所以必须在这里焙焙好。
     异步：首次需愵性加载 paper.js。 */
  function pathDataOf(obj) {
    if (!obj) return Promise.resolve(null);
    return ensurePaper().then(function () {
      var pp = objToPaper(obj);
      return pp ? String(pp.pathData) : null;
    });
  }

  /* 收集参与布尔的对象：① fabric 多选（Shift 点选）② 图层面板 Multi 勾选 —— 移动端没有 Shift，靠后者 */
  function boolTargets() {
    var c = CV(); if (!c) return [];
    var out = [];
    var seen = [];
    function push(o) {
      if (!o || o.isGrid || o.isPreview) return;
      if (/^(image|i-text|text|textbox)$/.test(String(o.type))) return;
      if (seen.indexOf(o) >= 0) return;
      seen.push(o); out.push(o);
    }
    if (c.getActiveObjects) c.getActiveObjects().forEach(push);
    if (window.__hdLayers && window.__hdLayers.multiOn && window.__hdLayers.multiOn() && window.__pfmLayerObjs) {
      var rev = window.__pfmLayerObjs().slice().reverse();
      rev.forEach(function (o, i) { if (window.__hdLayers.isPicked(i)) push(o); });
    }
    return out;
  }

  function boolOp(op) {
    var c = CV(); if (!c) return;
    var objs = boolTargets();
    if (objs.length < 2) { toast('Select 2 or more objects first'); return; }
    toast('Computing…');
    ensurePaper().then(function () {
      try { runBool(c, objs, op); }
      catch (e) { toast('Boolean failed: ' + (e && e.message || e)); }
    }).catch(function () { toast('Failed to load boolean engine'); });
  }

  function runBool(c, objs, op) {
    var pairs = [];
    objs.forEach(function (o) {
      var pp = objToPaper(o);
      if (pp) pairs.push({ obj: o, pp: pp });
    });
    if (pairs.length < 2) { toast('Unsupported object type'); return; }

    var res = pairs[0].pp.clone();
    for (var i = 1; i < pairs.length; i++) {
      var other = pairs[i].pp.clone();
      if (op === 'unite') res = res.unite(other);
      else if (op === 'subtract') res = res.subtract(other);
      else if (op === 'intersect') res = res.intersect(other);
      else if (op === 'exclude') res = res.exclude(other);
      else return;
    }
    var empty = (!res) || (res.area === 0 && !(res.children && res.children.length));
    if (empty) { toast('Result is empty'); return; }

    var src = pairs[0].obj;
    var attrs = {
      fill: src.fill, stroke: src.stroke,
      strokeWidth: src.strokeWidth || 0, strokeUniform: true
    };
    if (src.type === 'line') attrs.fill = null;

    var f = toFabricPath(res, attrs);
    f.pfmName = 'Boolean';
    f.pfmShapeKind = 'path';

    /* ⚠️ 此处**不要**再补一次 saveState：主 IIFE 的 saveState 带 300ms 防抖且
       clearTimeout 会取消上一个待入栈的快照 —— 补记反而会把「布尔之前那一步
       （创建对象）待入栈的快照」冲掉，导致撤销栈里没有可回退的形态。
       正确依赖：c.add(f) 触发 object:added → 自动 saveState（操作后），
       而「操作前」的状态已由用户此前各步操作正常入栈。 */
    objs.forEach(function (o) { try { c.remove(o); } catch (e) { } });
    c.add(f);
    c.setActiveObject(f);
    c.renderAll();
    if (D && D.save) { try { D.save(); } catch (e) { } }
    if (D && D.refresh) { try { D.refresh(); } catch (e) { } }
    toast('Boolean applied');
  }

  /* ================= 形状面板 ================= */
  var SHAPES = [
    { k: 'rect',     ico: '<rect x="4" y="6" width="16" height="12" rx="2"/>', lb: 'Rect' },
    { k: 'ellipse',  ico: '<ellipse cx="12" cy="12" rx="9" ry="7"/>', lb: 'Ellipse' },
    { k: 'triangle', ico: '<path d="M12 4l9 16H3z"/>', lb: 'Triangle' },
    { k: 'polygon',  ico: '<path d="M12 3l8 6-3 10H7L4 9z"/>', lb: 'Polygon' },
    { k: 'star',     ico: '<path d="M12 3l2.6 6.2 6.4.5-4.9 4.2 1.5 6.1L12 16.7 6.4 20l1.5-6.1L3 9.7l6.4-.5z"/>', lb: 'Star' },
    { k: 'line',     ico: '<path d="M4 19L20 5"/>', lb: 'Line' }
  ];

  function renderPanel() {
    if (!ROOT) return;
    var s = loadStyle();
    var grid = SHAPES.map(function (it) {
      return '<button class="pfm-shape-btn" type="button" data-kind="' + it.k + '" title="' + it.lb + '">'
           +   '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" '
           +   'stroke-width="1.6" stroke-linejoin="round" aria-hidden="true">' + it.ico + '</svg>'
           +   '<span class="pfm-shape-lb">' + it.lb + '</span></button>';
    }).join('');

    ROOT.innerHTML =
        '<div class="pfm-shape-grid">' + grid + '</div>'
      + '<div class="pfm-shape-sec">'
      +   '<div class="pfm-shape-row">'
      +     '<label class="pfm-shape-lab" for="pfmVStroke">Stroke</label>'
      +     '<input type="color" class="pfm-shape-color" id="pfmVStroke" value="' + (s.stroke || '#111111') + '">'
      +   '</div>'
      +   '<div class="pfm-shape-row">'
      +     '<label class="pfm-shape-lab" for="pfmVStrokeW">Width</label>'
      +     '<input type="range" class="pfm-shape-range" id="pfmVStrokeW" min="0" max="20" step="1" value="' + (s.strokeWidth || 0) + '">'
      +     '<span class="pfm-shape-val" id="pfmVStrokeWVal">' + (s.strokeWidth || 0) + '</span>'
      +   '</div>'
      +   '<div class="pfm-shape-row">'
      +     '<label class="pfm-shape-lab" for="pfmVDash">Dash</label>'
      +     '<select class="pfm-shape-sel" id="pfmVDash">' + opts(DASHES, s.dash || 'solid') + '</select>'
      +   '</div>'
      +   '<div class="pfm-shape-row">'
      +     '<label class="pfm-shape-lab" for="pfmVCap">Ends</label>'
      +     '<select class="pfm-shape-sel" id="pfmVCap">' + opts(CAPS, s.cap || 'butt') + '</select>'
      +   '</div>'
      +   '<div class="pfm-shape-row">'
      +     '<label class="pfm-shape-lab" for="pfmVJoin">Joints</label>'
      +     '<select class="pfm-shape-sel" id="pfmVJoin">' + opts(JOINS, s.join || 'miter') + '</select>'
      +   '</div>'
      +   '<div class="pfm-shape-row" id="pfmVCornerRow">'
      +     '<label class="pfm-shape-lab" for="pfmVCorner">Corner</label>'
      +     '<input type="range" class="pfm-shape-range" id="pfmVCorner" min="0" max="200" step="2" value="' + (s.corner || 0) + '">'
      +     '<span class="pfm-shape-val" id="pfmVCornerVal">' + (s.corner || 0) + '</span>'
      +   '</div>'
      +   '<div class="pfm-shape-row" id="pfmVPointsRow">'
      +     '<label class="pfm-shape-lab" for="pfmVPoints">Points</label>'
      +     '<input type="range" class="pfm-shape-range" id="pfmVPoints" min="3" max="12" step="1" value="' + (s.sides || s.points || 5) + '">'
      +     '<span class="pfm-shape-val" id="pfmVPointsVal">' + (s.sides || s.points || 5) + '</span>'
      +   '</div>'
      + '</div>'
      + '<p class="pfm-shape-hint">Tap a shape to place it in the print area.</p>';

    bindPanel();
  }

  /* ================= 填充面板 ================= */
  function renderFill() {
    if (!FROOT) return;
    var f = loadFill();
    var sw = SWATCHES.map(function (c) {
      return '<button class="pfm-swatch" type="button" data-c="' + c + '" title="' + c + '" '
           + 'style="background:' + c + '"></button>';
    }).join('');

    FROOT.innerHTML =
        '<div class="pfm-shape-row pfm-fill-tabs">'
      +   '<button class="pfm-fill-tab" type="button" data-ft="solid">Solid</button>'
      +   '<button class="pfm-fill-tab" type="button" data-ft="linear">Linear</button>'
      +   '<button class="pfm-fill-tab" type="button" data-ft="radial">Radial</button>'
      +   '<button class="pfm-fill-tab" type="button" data-ft="pattern">Pattern</button>'
      + '</div>'
      + '<div class="pfm-shape-row pfm-pat-row" id="pfmVPatRow">'
      +   PATTERNS.map(function (p) {
            return '<button class="pfm-pat-chip" type="button" data-pt="' + p[0] + '">' + p[1] + '</button>';
          }).join('')
      + '</div>'
      + '<div class="pfm-shape-row" id="pfmVFillARow" data-slot="a">'
      +   '<label class="pfm-shape-lab">' + (f.type === 'solid' ? 'Color' : 'From') + '</label>'
      +   '<span class="pfm-fill-chip" id="pfmVFillAChip" style="background:' + (f.a || '#7C3AED') + '"></span>'
      +   '<input type="color" class="pfm-shape-color pfm-fill-native" id="pfmVFillA" value="' + (f.a || '#7C3AED') + '" tabindex="-1" aria-hidden="true">'
      +   '<span class="pfm-shape-val" id="pfmVFillAVal"></span>'
      + '</div>'
      + '<div class="pfm-shape-row" id="pfmVFillBRow" data-slot="b">'
      +   '<label class="pfm-shape-lab">To</label>'
      +   '<span class="pfm-fill-chip" id="pfmVFillBChip" style="background:' + (f.b || '#EC4899') + '"></span>'
      +   '<input type="color" class="pfm-shape-color pfm-fill-native" id="pfmVFillB" value="' + (f.b || '#EC4899') + '" tabindex="-1" aria-hidden="true">'
      + '</div>'
      + '<div class="pfm-shape-row" id="pfmVFillCRow" data-slot="c">'
      +   '<label class="pfm-shape-lab">Mid</label>'
      +   '<span class="pfm-fill-chip" id="pfmVFillCChip" style="background:' + (f.c || '#F59E0B') + '"></span>'
      +   '<input type="color" class="pfm-shape-color pfm-fill-native" id="pfmVFillC" value="' + (f.c || '#F59E0B') + '" tabindex="-1" aria-hidden="true">'
      +   '<input type="range" class="pfm-shape-range" id="pfmVFillCP" min="5" max="95" step="5" value="' + (f.cp == null ? 50 : f.cp) + '">'
      +   '<span class="pfm-shape-val" id="pfmVFillCPVal">' + (f.cp == null ? 50 : f.cp) + '%</span>'
      + '</div>'
      + '<div class="pfm-shape-row pfm-stop-row" id="pfmVStopRow">'
      +   '<label class="pfm-shape-lab">Stops</label>'
      +   '<div class="pfm-tx-seg pfm-stop-seg">'
      +     '<button class="pfm-tx-chip" type="button" data-cs="2">2 colors</button>'
      +     '<button class="pfm-tx-chip" type="button" data-cs="3">3 colors</button>'
      +   '</div>'
      + '</div>'
      + '<div class="pfm-shape-row" id="pfmVAngleRow">'
      +   '<label class="pfm-shape-lab" for="pfmVAngle">Angle</label>'
      +   '<input type="range" class="pfm-shape-range" id="pfmVAngle" min="0" max="360" step="5" value="' + (f.angle || 0) + '">'
      +   '<span class="pfm-shape-val" id="pfmVAngleVal">' + (f.angle || 0) + '°</span>'
      + '</div>'
      + '<div class="pfm-shape-row" id="pfmVPatScaleRow">'
      +   '<label class="pfm-shape-lab" for="pfmVPatScale">Pattern size</label>'
      +   '<input type="range" class="pfm-shape-range" id="pfmVPatScale" min="50" max="300" step="10" value="' + Math.round((f.patScale || 1) * 100) + '">'
      +   '<span class="pfm-shape-val" id="pfmVPatScaleVal">' + Math.round((f.patScale || 1) * 100) + '%</span>'
      + '</div>'
      + '<div class="pfm-shape-row pfm-swatch-row">' + sw
      +   '<button class="pfm-swatch-add" type="button" id="pfmFillCustom" title="Custom color \u2014 opens the color picker for the highlighted slot">'
      +     svgIco('<path d="M12 5v14"/><path d="M5 12h14"/>')
      +   '</button>'
      + '</div>'
      + '<div class="pfm-shape-row pfm-swatch-row" id="pfmVRecentRow"></div>'
      + '<div class="pfm-shape-row pfm-swatch-row" id="pfmVBrandRow"></div>'
      + '<p class="pfm-shape-hint" id="pfmVFillHint"></p>';

    bindFill();
    renderBoards();
    syncFill();
  }

  /* 最近颜色 / 品牌色两条色板行（#12）。品牌色可存当前色、可整组清空。 */
  function renderBoards() {
    var rec = loadList(LS_RECENT);
    var rr = q('pfmVRecentRow');
    if (rr) {
      rr.style.display = rec.length ? '' : 'none';
      rr.innerHTML = '<span class="pfm-sw-lab">Recent</span>' + rec.map(function (c) {
        return '<button class="pfm-swatch" type="button" data-c="' + c + '" title="' + c + '" style="background:' + c + '"></button>';
      }).join('');
    }
    var br = loadList(LS_BRAND);
    var bd = q('pfmVBrandRow');
    if (bd) {
      bd.innerHTML = '<span class="pfm-sw-lab">Brand</span>' + br.map(function (c) {
        return '<button class="pfm-swatch" type="button" data-c="' + c + '" title="' + c + '" style="background:' + c + '"></button>';
      }).join('')
        + '<button class="pfm-swatch-add" type="button" id="pfmBrandAdd" title="Save current color">'
        +   svgIco('<path d="M12 5v14"/><path d="M5 12h14"/>') + '</button>'
        + '<button class="pfm-swatch-add" type="button" id="pfmBrandClear" title="Clear saved colors">'
        +   svgIco('<path d="M6 6l12 12"/><path d="M18 6L6 18"/>') + '</button>';
    }
  }

  /* ================= 事件绑定 ================= */
  function bindPanel() {
    if (bound || !ROOT) return;
    bound = true;
    ROOT.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.pfm-shape-btn') : null;
      if (b && ROOT.contains(b)) addShape(b.dataset.kind);
    });
    var stc = q('pfmVStroke');
    if (stc) stc.addEventListener('input', function () { setStyle({ stroke: this.value }); });
    var sw = q('pfmVStrokeW');
    if (sw) sw.addEventListener('input', function () {
      var v = parseInt(this.value, 10) || 0;
      var l = q('pfmVStrokeWVal'); if (l) l.textContent = v;
      setStyle({ strokeWidth: v });
    });
    var dh = q('pfmVDash');
    if (dh) dh.addEventListener('change', function () { setStyle({ dash: this.value }); });
    var cp = q('pfmVCap');
    if (cp) cp.addEventListener('change', function () { setStyle({ cap: this.value }); });
    var jn = q('pfmVJoin');
    if (jn) jn.addEventListener('change', function () { setStyle({ join: this.value }); });
    var cr = q('pfmVCorner');
    if (cr) cr.addEventListener('input', function () {
      var v = parseInt(this.value, 10) || 0;
      var l = q('pfmVCornerVal'); if (l) l.textContent = v;
      setStyle({ corner: v });
    });
    var pt = q('pfmVPoints');
    if (pt) pt.addEventListener('input', function () {
      var v = parseInt(this.value, 10) || 5;
      var l = q('pfmVPointsVal'); if (l) l.textContent = v;
      setStyle({ sides: v, points: v });
    });
  }

  function bindFill() {
    if (fbound || !FROOT) return;
    fbound = true;
    FROOT.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      /* 2026-10-28（甲）：点 From / To / Mid 任一行（行内滑块除外）⇒ 色板切到该色槽 */
      var rowEl = t.closest('[data-slot]');
      if (rowEl && FROOT.contains(rowEl) && !t.closest('input[type="range"]')) setCurSlot(rowEl.dataset.slot);
      /* 2026-10-28（甲·2）：「+」= 唯一打开系统调色板的入口，作用于当前色槽 */
      var cu = t.closest('#pfmFillCustom');
      if (cu && FROOT.contains(cu)) {
        var _k = curSlot();
        var _inp = q(_k === 'a' ? 'pfmVFillA' : (_k === 'b' ? 'pfmVFillB' : 'pfmVFillC'));
        if (_inp) {
          try { var _cv = loadFill()[_k]; if (_cv) _inp.value = _cv; } catch (e0) {}
          try { _inp.click(); } catch (e1) {}
        }
        return;
      }
      var tab = t.closest('.pfm-fill-tab');
      if (tab && FROOT.contains(tab)) { setFill({ type: tab.dataset.ft }); return; }
      var sw = t.closest('.pfm-swatch');
      if (sw && FROOT.contains(sw)) {
        /* 写到「当前色槽」而不是写死 From（Recent / Brand 色块同走这条） */
        var _sp = {}; _sp[curSlot()] = sw.dataset.c;
        setFill(_sp); return;
      }
      var ad = t.closest('.pfm-swatch-add');
      if (ad && FROOT.contains(ad)) {
        if (ad.id === 'pfmBrandClear') { saveList(LS_BRAND, []); }
        else {
          var _fv = loadFill(), cc = _fv[curSlot()] || _fv.a, lb = loadList(LS_BRAND);
          lb.unshift(cc); saveList(LS_BRAND, lb.slice(0, BRAND_MAX));
        }
        renderBoards(); return;
      }
      var c3 = t.closest('[data-cs]');
      if (c3 && FROOT.contains(c3)) { setFill({ cOn: c3.dataset.cs === '3' }); return; }
      var p3 = t.closest('[data-pt]');
      if (p3 && FROOT.contains(p3)) { setFill({ pat: p3.dataset.pt, type: 'pattern' }); return; }
    });
    var fa = q('pfmVFillA');
    if (fa) {
      fa.addEventListener('input', function () { setFill({ a: this.value }); });
      /* 记录「最近使用」用 change 而不是 input —— 原生取色器拖动时会连续触发 input，
         那样会在拖动过程中反复重建色板行。 */
      fa.addEventListener('change', function () { pushRecent(this.value); renderBoards(); });
    }
    var fb = q('pfmVFillB');
    if (fb) fb.addEventListener('input', function () { setFill({ b: this.value }); });
    var ag = q('pfmVAngle');
    if (ag) ag.addEventListener('input', function () {
      var v = parseInt(this.value, 10) || 0;
      var l = q('pfmVAngleVal'); if (l) l.textContent = v + '°';
      setFill({ angle: v });
    });
    var fc = q('pfmVFillC');
    if (fc) {
      fc.addEventListener('input', function () { setFill({ c: this.value }); });
      fc.addEventListener('change', function () { pushRecent(this.value); renderBoards(); });
    }
    var fp = q('pfmVFillCP');
    if (fp) fp.addEventListener('input', function () {
      var v = parseInt(this.value, 10) || 50;
      var l = q('pfmVFillCPVal'); if (l) l.textContent = v + '%';
      setFill({ cp: v });
    });
    var psz = q('pfmVPatScale');
    if (psz) psz.addEventListener('input', function () {
      var v = parseInt(this.value, 10) || 100;
      var l = q('pfmVPatScaleVal'); if (l) l.textContent = v + '%';
      setFill({ patScale: v / 100 });
    });
  }

  /* ================= 样式变更 → LS + 实时套用 ================= */
  function setStyle(patch) {
    var s = loadStyle(); Object.assign(s, patch); writeLS(LS_SHAPE, s);
    applyShapeToSelection();
    /* 描边样式独立套用：它作用于**任何**带 stroke 的对象（含路径/多选），
       而 applyShapeToSelection 只管形状参数。线宽变化时也要重算虚线间距。 */
    applyStrokeStyle();
    syncProps();
  }
  function setFill(patch) {
    var f = loadFill(); Object.assign(f, patch); writeLS(LS_FILL, f);
    applyFillToSelection();
    syncFill(); syncProps();
  }

  function applyShapeToSelection() {
    var c = CV(); if (!c) return;
    var o = c.getActiveObject();
    if (!o || !isShape(o)) return;
    var s = loadStyle();
    var props = {};
    if (o.type === 'line') {
      props.stroke = s.stroke || '#111111';
      props.strokeWidth = Math.max(2, s.strokeWidth || 2);
    } else {
      props.stroke = (s.strokeWidth > 0) ? s.stroke : null;
      props.strokeWidth = (s.strokeWidth > 0) ? s.strokeWidth : 0;
    }
    if (o.type === 'rect') { props.rx = s.corner || 0; props.ry = s.corner || 0; }
    if ((o.pfmShapeKind === 'polygon' || o.pfmShapeKind === 'star') && o.getCenterPoint) {
      var ctr = o.getCenterPoint();
      var half = (o.width || 100) / 2;
      var pts = (o.pfmShapeKind === 'polygon')
        ? polyPoints(Math.max(3, Math.min(12, s.sides || 6)), half)
        : starPoints(Math.max(3, Math.min(12, s.points || 5)), half, 0.42);
      o.set({ points: pts });
      if (o.setPositionByOrigin) o.setPositionByOrigin(ctr, 'center', 'center');
    }
    o.set(props);
    if (o.setCoords) o.setCoords();
    c.renderAll();
    if (D && D.save) { try { D.save(); } catch (e) { } }
  }

  /* ================= 上下文同步 ================= */
  function sel() {
    var c = CV(); if (!c) return null;
    var o = c.getActiveObject();
    if (!o || o.type === 'group' || o.type === 'activeSelection') return null;
    return o;
  }

  /* 形状面板：Corner 仅矩形 / Points 仅多边形·星形（常驻，不用时整行隐藏） */
  function syncProps() {
    if (!ROOT) return;
    var o = sel();
    var sh = o && isShape(o) ? o : null;
    var kd = sh ? (sh.pfmShapeKind || '') : '';
    var cr = q('pfmVCornerRow'); if (cr) cr.style.display = (kd === 'rect') ? '' : 'none';
    var pr = q('pfmVPointsRow'); if (pr) pr.style.display = (kd === 'polygon' || kd === 'star') ? '' : 'none';

    var s = loadStyle();
    if (sh) {
      if (typeof sh.stroke === 'string' && sh.stroke.charAt(0) === '#') {
        var si = q('pfmVStroke'); if (si) si.value = sh.stroke;
        s.stroke = sh.stroke;
      }
      var swv = Math.round(sh.strokeWidth || 0);
      var swi = q('pfmVStrokeW'); if (swi) swi.value = swv;
      var swl = q('pfmVStrokeWVal'); if (swl) swl.textContent = swv;
      s.strokeWidth = swv;
      /* 2026-09-16: 描边样式回填 —— 从对象反推（虚线数组按线宽反解成档位） */
      var da = sh.strokeDashArray;
      var dk = 'solid';
      if (Array.isArray(da) && da.length) {
        var ratio = da[0] / Math.max(1, sh.strokeWidth || 1);
        dk = (da.length >= 4) ? 'dashdot' : (ratio < 1 ? 'dot' : 'dash');
      }
      var dsel = q('pfmVDash'); if (dsel) dsel.value = dk;
      var csel = q('pfmVCap'); if (csel) csel.value = sh.strokeLineCap || 'butt';
      var jsel = q('pfmVJoin'); if (jsel) jsel.value = sh.strokeLineJoin || 'miter';
      s.dash = dk; s.cap = sh.strokeLineCap || 'butt'; s.join = sh.strokeLineJoin || 'miter';
      if (kd === 'rect') {
        var cv = Math.round(sh.rx || 0);
        var ci = q('pfmVCorner'); if (ci) ci.value = cv;
        var cl = q('pfmVCornerVal'); if (cl) cl.textContent = cv;
        s.corner = cv;
      }
    }
    ROOT.classList.toggle('pfm-shape-has-sel', !!sh);
  }

  /* 填充面板：按选中对象切换「显示 / 置灰」。
     显示时机与 #pfmActionsSection 保持一致（选中对象时才出现）——
     未选中时它没有可编辑目标，常驻会是空占位。 */
  /* 面板模式跟随选中对象的填充种类（纯色 / 线性 / 径向 / 图案）——
     否则「选中一个图案对象」时面板还停在上次的渐变模式，显示的行与实际对象对不上。 */
  function adoptFill(o, canFill) {
    var f = loadFill();
    if (!o || !canFill) return;
    var fv = o.fill;
    if (isGrad(fv)) {
      var cs = fv.colorStops || [];
      f.type = (fv.type === 'radial') ? 'radial' : 'linear';
      if (cs.length >= 3) {
        f.a = cs[0].color; f.c = cs[1].color; f.b = cs[2].color;
        f.cOn = true; f.cp = Math.round((cs[1].offset || 0.5) * 100);
      } else {
        if (cs[0] && cs[0].color) f.a = cs[0].color;
        if (cs[1] && cs[1].color) f.b = cs[1].color;
        f.cOn = false;
      }
    } else if (isPat(fv)) {
      f.type = 'pattern';
      var pv = o.__pfmPat;
      if (pv) { f.pat = pv.kind || 'dots'; f.a = pv.color || f.a; f.patScale = pv.scale || 1; }
    } else if (typeof fv === 'string' && fv.charAt(0) === '#') {
      f.type = 'solid'; f.a = fv;
    }
    writeLS(LS_FILL, f);
  }

  function syncFill() {
    if (!FROOT) return;
    var f = loadFill();
    var tg = fillTargets();
    var o = tg[0] || null;                  /* 回填用第一个可填充对象（多选时即第一个子对象） */
    var canFill = tg.length > 0;
    adoptFill(o, canFill);
    var isGradMode = (f.type === 'linear' || f.type === 'radial');
    var isPat = (f.type === 'pattern');

    var sec = q('pfmFillSection');
    if (sec) sec.style.display = canFill ? '' : 'none';

    /* tab 选中态 */
    Array.prototype.forEach.call(FROOT.querySelectorAll('.pfm-fill-tab'), function (b) {
      b.classList.toggle('on', b.dataset.ft === f.type);
    });
    /* 有条件显示的行 */
    var bRow = q('pfmVFillBRow'); if (bRow) bRow.style.display = isGradMode ? '' : 'none';
    var aRow = q('pfmVAngleRow'); if (aRow) aRow.style.display = (f.type === 'linear') ? '' : 'none';
    var cRow = q('pfmVFillCRow'); if (cRow) cRow.style.display = (isGradMode && f.cOn) ? '' : 'none';
    var stRow = q('pfmVStopRow'); if (stRow) stRow.style.display = isGradMode ? '' : 'none';
    var ptRow = q('pfmVPatRow'); if (ptRow) ptRow.style.display = isPat ? '' : 'none';
    var scRow = q('pfmVPatScaleRow'); if (scRow) scRow.style.display = isPat ? '' : 'none';
    Array.prototype.forEach.call(FROOT.querySelectorAll('[data-cs]'), function (b) {
      b.classList.toggle('on', (b.dataset.cs === '3') === !!f.cOn);
    });
    Array.prototype.forEach.call(FROOT.querySelectorAll('[data-pt]'), function (b) {
      b.classList.toggle('on', b.dataset.pt === (f.pat || 'dots'));
    });
    /* 「From」标签在渐变模式下更贴切 */
    var lab = FROOT.querySelector('[data-slot="a"] .pfm-shape-lab');
    if (lab) lab.textContent = isGradMode ? 'From' : 'Color';

    /* 回填控件（状态已在 adoptFill() 里从对象取回，这里只写 UI） */
    if (o && canFill) {
      var ia = q('pfmVFillA'); if (ia) ia.value = f.a;
      var ib = q('pfmVFillB'); if (ib) ib.value = f.b;
      var ic = q('pfmVFillC'); if (ic) ic.value = f.c;
      /* 2026-10-28（甲·2）：色块改为纯展示 ⇒ 每次同步都要刷背景 */
      var _ca = q('pfmVFillAChip'); if (_ca) _ca.style.background = f.a;
      var _cb = q('pfmVFillBChip'); if (_cb) _cb.style.background = f.b;
      var _cc = q('pfmVFillCChip'); if (_cc) _cc.style.background = f.c;
      var ip = q('pfmVFillCP'); if (ip) ip.value = f.cp;
      var ipl = q('pfmVFillCPVal'); if (ipl) ipl.textContent = f.cp + '%';
      var iw = q('pfmVPatScale'); if (iw) iw.value = Math.round((f.patScale || 1) * 100);
      var iwl = q('pfmVPatScaleVal');
      if (iwl) iwl.textContent = Math.round((f.patScale || 1) * 100) + '%';
    }
    /* 禁用态（无选中 / 线对象） */
    Array.prototype.forEach.call(FROOT.querySelectorAll('input,button'), function (el) {
      if (el.classList.contains('pfm-fill-tab')) return;
      el.disabled = !canFill;
    });
    var hint = q('pfmVFillHint');
    if (hint) hint.textContent = canFill ? '' : 'Select an object to change its fill.';
    FROOT.classList.toggle('pfm-fill-has-sel', !!canFill);
    /* 2026-10-28（甲）：高亮当前色槽 —— 让用户一眼看出色板改的是哪一色 */
    syncCurSlot();
  }

  /* ================= 布尔面板 ================= */
  var BOOL_OPS = [
    { k: 'unite',     lb: 'Weld',      t: 'Weld (unite) — merge all into one' },
    { k: 'subtract',  lb: 'Trim',      t: 'Trim — subtract upper objects from the lowest one' },
    { k: 'intersect', lb: 'Intersect', t: 'Intersect — keep only the overlapping part' },
    { k: 'exclude',   lb: 'Simplify',  t: 'Simplify — remove the overlapping part' }
  ];

  function renderBool() {
    var B = q('pfmBoolPanel');
    if (!B) return;
    B.innerHTML =
        '<div class="pfm-bool-row">'
      + BOOL_OPS.map(function (o) {
          return '<button class="pfm-bool-btn" type="button" data-op="' + o.k + '" title="' + o.t + '">' + o.lb + '</button>';
        }).join('')
      + '</div>'
      + '<p class="pfm-shape-hint" id="pfmBoolHint"></p>';
    if (!B._bound) {
      B._bound = true;
      B.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest) {
          var btn = t.closest('.pfm-bool-btn');
          if (btn && B.contains(btn)) boolOp(btn.dataset.op);
        }
      });
    }
  }

  /* 布尔区上下文：仅当可运算对象 ≥2 时出现 */
  function syncBool() {
    var sec = q('pfmBoolSection');
    if (!sec) return;
    var n = boolTargets().length;
    sec.style.display = (n >= 2) ? '' : 'none';
    var hint = q('pfmBoolHint');
    if (hint && n >= 2) hint.textContent = n + ' objects selected · the lowest object keeps its style.';
  }

  /* ================= init（幂等，可反复调用） ================= */
  function init(deps) {
    if (D) { try { syncProps(); syncFill(); syncBool(); } catch (e) { } return; }
    D = deps || {};
    ROOT = q('pfmShapePanel');
    FROOT = q('pfmFillPanel');
    loadStyle(); loadFill();
    if (ROOT) { renderPanel(); }
    if (FROOT) { renderFill(); syncFill(); }
    renderBool();
    syncBool();
    var c = CV();
    if (c && c.on) {
      try {
        c.on('selection:created', function () { syncProps(); syncFill(); syncBool(); });
        c.on('selection:updated', function () { syncProps(); syncFill(); syncBool(); });
        c.on('selection:cleared', function () { syncProps(); syncFill(); syncBool(); });
      } catch (e) { }
    }
  }

  window.__hdVector = {
    init: init,
    addShape: addShape,
    isShape: isShape,
    syncProps: syncProps,
    syncFill: syncFill,
    syncBool: syncBool,
    boolOp: boolOp,
    pathDataOf: pathDataOf
  };

  /* 供其它外置引擎（如 hd-pick.js 的吸管）记录「最近使用色」 */
  try {
    if (window.__hdVector) {
      window.__hdVector.recent = function (h) { pushRecent(h); renderBoards(); };
    }
  } catch (e) { }
})();
